import React from "react";
import { Card, FormLayout, TextField, Select } from "@shopify/polaris";
import PropTypes from "prop-types";

import constant from "lib/constant/constant";

const Inventory = (props) => {
  const { variantData = {}, handleChange = () => {}, handleTitleChange = () => {}, cms, setDisabledButton } = props;
  const { barcode = null, inventoryManagement = null, inventoryQuantity = 0, sku = "" } = variantData;
  const isDisabled = inventoryManagement !== constant.SHOPIFY;

  const options = [
    { label: cms("section.inventory.label.noTrack"), value: constant.DO_NOT_TRACK_INVENTORY },
    { label: cms("section.inventory.label.shopify"), value: constant.SHOPIFY },
  ];

  return (
    <Card title={cms("section.inventory.title")} id="variantInventory" sectioned>
      <FormLayout>
        <FormLayout.Group>
          <TextField
            id="sku"
            label={cms("section.inventory.label.sku")}
            value={sku || ""}
            onChange={(value) => {
              handleChange(constant.SKU, value);
              setDisabledButton(false);
            }}
          />
        </FormLayout.Group>
        <FormLayout.Group>
          <TextField
            id="barcode"
            label={cms("section.inventory.label.barcode")}
            value={barcode || ""}
            onChange={(value) => {
              handleTitleChange(constant.BARCODE, value);
              setDisabledButton(false);
            }}
          />
        </FormLayout.Group>
        <FormLayout.Group>
          <Select
            id="policySelection"
            label={cms("section.inventory.label.policy")}
            options={options}
            value={inventoryManagement || ""}
            onChange={(value) => {
              handleTitleChange(constant.INVENTORY_MANAGEMENT, value);
              setDisabledButton(false);
              if (value !== constant.SHOPIFY) {
                handleChange(constant.INVENTORY_QUANTITY, 0);
              }
            }}
          />
        </FormLayout.Group>
        {inventoryManagement === constant.SHOPIFY ? (
          <FormLayout.Group>
            <TextField
              id="inventoryQuantity"
              disabled={isDisabled}
              label={cms("section.inventory.label.quantity")}
              value={(inventoryQuantity && inventoryQuantity.toString()) || ""}
              onChange={(value) => {
                handleChange(constant.INVENTORY_QUANTITY, Number(value));
                setDisabledButton(false);
              }}
            />
          </FormLayout.Group>
        ) : (
          ""
        )}
      </FormLayout>
    </Card>
  );
};

Inventory.propTypes = {
  variantData: PropTypes.objectOf(PropTypes.shape).isRequired,
  handleChange: PropTypes.func.isRequired,
  handleTitleChange: PropTypes.func.isRequired,
  cms: PropTypes.func.isRequired,
  setDisabledButton: PropTypes.func.isRequired,
};

export default Inventory;
